import { render, staticRenderFns } from "./dressSelectionTable.vue?vue&type=template&id=1e95b9f5&scoped=true"
import script from "./dressSelectionTable.vue?vue&type=script&lang=js"
export * from "./dressSelectionTable.vue?vue&type=script&lang=js"
import style0 from "./dressSelectionTable.vue?vue&type=style&index=0&id=1e95b9f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e95b9f5",
  null
  
)

export default component.exports